import type {BoardColumn} from '@github-ui/board-core'
import {replaceDateTokens} from '@github-ui/issue-url-helper'
import {useCallback, useMemo} from 'react'

import {BoardCard} from '../components/board/issues/BoardCard'
import type {BoardPayloadItem} from '../components/board/issues/board-payload'
import {LabelColumnHeader} from '../components/board/issues/LabelColumnHeader'
import type {BoardColumnLabels} from '../components/board/issues/proto-to-board-payload-mapper'
import {SavedViewBoard} from '../components/board/SavedViewBoard'
import {useVisibleFieldIdentifiers} from '../contexts/views/VisibleFieldsProvider'
import {createRepositoryBoardAdapter} from '../helpers/create-repository-board-adapter'

export function RepositorySavedViewBoard({owner, repo, query}: {owner: string; repo: string; query: string}) {
  const visibleFieldIdentifiers = useVisibleFieldIdentifiers()
  const adapter = useMemo(() => createRepositoryBoardAdapter({owner, repo}), [owner, repo])
  const renderColumnHeader = useCallback(
    (column: BoardColumn, columnLabels: BoardColumnLabels) => (
      <LabelColumnHeader column={column} columnLabels={columnLabels} />
    ),
    [],
  )

  const renderCard = useCallback(
    (item: BoardPayloadItem) => <BoardCard item={item} visibleFieldIdentifiers={visibleFieldIdentifiers} />,
    [visibleFieldIdentifiers],
  )

  return (
    <SavedViewBoard
      adapter={adapter}
      options={{query: replaceDateTokens(query)}}
      renderCard={renderCard}
      renderColumnHeader={renderColumnHeader}
    />
  )
}
